import { render, staticRenderFns } from "./todoList.vue?vue&type=template&id=b4a3326e&scoped=true"
import script from "./todoList.vue?vue&type=script&lang=js"
export * from "./todoList.vue?vue&type=script&lang=js"
import style0 from "./todoList.vue?vue&type=style&index=0&id=b4a3326e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a3326e",
  null
  
)

export default component.exports